module.exports = __webpack_public_path__ + "static/media/web-search-top-authors.8a41a1bd.png";